var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHugeiconsWeightScale(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 53,
    viewBox: "0 0 54 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3728 11.0432C12.3591 11.1801 10.4979 11.604 9.182 12.9221C7.2413 14.865 7.2413 17.9935 7.2413 24.2483V35.3074C7.2413 41.5623 7.2413 44.6908 9.182 46.6337C11.1205 48.5766 14.2446 48.5766 20.4884 48.5766H33.7354C39.9792 48.5766 43.1033 48.5766 45.0418 46.6337C46.9803 44.6908 46.9825 41.5623 46.9825 35.3074V24.2461C46.9825 17.9913 46.9825 14.8628 45.0418 12.9199C43.7259 11.6018 41.8625 11.1757 38.851 11.041",
    stroke: "white",
    strokeWidth: 3.31177,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1278 14.4435C15.0681 10.2928 14.5382 8.21742 15.3993 6.694C15.63 6.28821 15.9236 5.92157 16.2691 5.60774C17.5696 4.41992 19.7575 4.41992 24.1313 4.41992H30.0925C34.4662 4.41992 36.6542 4.41992 37.9546 5.60774C38.3012 5.92346 38.5949 6.29217 38.8245 6.69621C39.6856 8.21962 39.1557 10.295 38.0959 14.4457C37.2481 17.7531 36.8264 19.4068 35.696 20.4952C35.3869 20.794 35.0476 21.0538 34.6782 21.2746C33.3225 22.0827 31.5783 22.0827 28.0922 22.0827H26.1316C22.6432 22.0827 20.899 22.0827 19.5456 21.2746C19.1792 21.0542 18.8385 20.7935 18.53 20.4974C17.3974 19.4068 16.9734 17.7531 16.1278 14.4435Z",
    stroke: "white",
    strokeWidth: 3.31177,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6962 39.7453H31.5276M26.008 22.0825L28.2158 15.459",
    stroke: "white",
    strokeWidth: 3.31177,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHugeiconsWeightScale);
export default __webpack_public_path__ + "static/media/hugeicons_weight-scale.baf9239ec7bb98584acff6916157126b.svg";
export { ForwardRef as ReactComponent };